/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestError from '../model/BadRequestError';
import ContentSitemapNodeCreate from '../model/ContentSitemapNodeCreate';
import ContentSitemapNodeList from '../model/ContentSitemapNodeList';
import ContentSitemapNodeRead from '../model/ContentSitemapNodeRead';
import ForbiddenError from '../model/ForbiddenError';
import InlineObject19 from '../model/InlineObject19';
import NotAcceptableError from '../model/NotAcceptableError';
import NotFoundError from '../model/NotFoundError';
import ServiceUnavailableError from '../model/ServiceUnavailableError';
import SitemapCreate from '../model/SitemapCreate';
import SitemapList from '../model/SitemapList';
import SitemapNodeCreate from '../model/SitemapNodeCreate';
import SitemapNodeList from '../model/SitemapNodeList';
import SitemapNodeRead from '../model/SitemapNodeRead';
import SitemapNodeUpdate from '../model/SitemapNodeUpdate';
import SitemapNodeVersionList from '../model/SitemapNodeVersionList';
import SitemapNodeVersionRead from '../model/SitemapNodeVersionRead';
import SitemapNodeVersionWrite from '../model/SitemapNodeVersionWrite';
import SitemapRead from '../model/SitemapRead';
import SitemapUpdate from '../model/SitemapUpdate';
import UnauthorizedError from '../model/UnauthorizedError';

/**
* Sitemap service.
* @module api/SitemapApi
* @version 1.7.2
*/
export default class SitemapApi {

    /**
    * Constructs a new SitemapApi. 
    * @alias module:api/SitemapApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createContentSitemapNode operation.
     * @callback module:api/SitemapApi~createContentSitemapNodeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContentSitemapNodeRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a ContentSitemapNode resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} entityName 
     * @param {String} entityId 
     * @param {String} sitemapName 
     * @param {module:model/ContentSitemapNodeCreate} contentSitemapNode Required properties are: * sitemap_node 
     * @param {module:api/SitemapApi~createContentSitemapNodeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContentSitemapNodeRead}
     */
    createContentSitemapNode(acceptLanguage, entityName, entityId, sitemapName, contentSitemapNode, callback) {
      let postBody = contentSitemapNode;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createContentSitemapNode");
      }
      // verify the required parameter 'entityName' is set
      if (entityName === undefined || entityName === null) {
        throw new Error("Missing the required parameter 'entityName' when calling createContentSitemapNode");
      }
      // verify the required parameter 'entityId' is set
      if (entityId === undefined || entityId === null) {
        throw new Error("Missing the required parameter 'entityId' when calling createContentSitemapNode");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling createContentSitemapNode");
      }
      // verify the required parameter 'contentSitemapNode' is set
      if (contentSitemapNode === undefined || contentSitemapNode === null) {
        throw new Error("Missing the required parameter 'contentSitemapNode' when calling createContentSitemapNode");
      }

      let pathParams = {
        'entity_name': entityName,
        'entity_id': entityId,
        'sitemap_name': sitemapName
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ContentSitemapNodeRead;
      return this.apiClient.callApi(
        '/{entity_name}/{entity_id}/sitemaps/{sitemap_name}/nodes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createSitemap operation.
     * @callback module:api/SitemapApi~createSitemapCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Sitemap resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {module:model/SitemapCreate} sitemap Required properties are: * name 
     * @param {module:api/SitemapApi~createSitemapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapRead}
     */
    createSitemap(acceptLanguage, sitemap, callback) {
      let postBody = sitemap;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createSitemap");
      }
      // verify the required parameter 'sitemap' is set
      if (sitemap === undefined || sitemap === null) {
        throw new Error("Missing the required parameter 'sitemap' when calling createSitemap");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapRead;
      return this.apiClient.callApi(
        '/sitemaps', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createSitemapNode operation.
     * @callback module:api/SitemapApi~createSitemapNodeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapNodeRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a SitemapNode resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} sitemapName 
     * @param {module:model/SitemapNodeCreate} sitemapNode Required properties are: * title   For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/SitemapApi~createSitemapNodeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapNodeRead}
     */
    createSitemapNode(acceptLanguage, sitemapName, sitemapNode, callback) {
      let postBody = sitemapNode;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createSitemapNode");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling createSitemapNode");
      }
      // verify the required parameter 'sitemapNode' is set
      if (sitemapNode === undefined || sitemapNode === null) {
        throw new Error("Missing the required parameter 'sitemapNode' when calling createSitemapNode");
      }

      let pathParams = {
        'sitemap_name': sitemapName
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapNodeRead;
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createSitemapNodeVersion operation.
     * @callback module:api/SitemapApi~createSitemapNodeVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapNodeVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a SitemapNode resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} sitemapName 
     * @param {String} sitemapNodeId 
     * @param {module:model/SitemapNodeVersionWrite} sitemapNode Required properties are: * title   For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/SitemapApi~createSitemapNodeVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapNodeVersionRead}
     */
    createSitemapNodeVersion(acceptLanguage, sitemapName, sitemapNodeId, sitemapNode, callback) {
      let postBody = sitemapNode;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createSitemapNodeVersion");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling createSitemapNodeVersion");
      }
      // verify the required parameter 'sitemapNodeId' is set
      if (sitemapNodeId === undefined || sitemapNodeId === null) {
        throw new Error("Missing the required parameter 'sitemapNodeId' when calling createSitemapNodeVersion");
      }
      // verify the required parameter 'sitemapNode' is set
      if (sitemapNode === undefined || sitemapNode === null) {
        throw new Error("Missing the required parameter 'sitemapNode' when calling createSitemapNodeVersion");
      }

      let pathParams = {
        'sitemap_name': sitemapName,
        'sitemap_node_id': sitemapNodeId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapNodeVersionRead;
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes/{sitemap_node_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteContentSitemapNode operation.
     * @callback module:api/SitemapApi~deleteContentSitemapNodeCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the ContentSitemapNode resource.
     * @param {String} entityName 
     * @param {String} entityId 
     * @param {String} sitemapName 
     * @param {String} id 
     * @param {module:api/SitemapApi~deleteContentSitemapNodeCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteContentSitemapNode(entityName, entityId, sitemapName, id, callback) {
      let postBody = null;
      // verify the required parameter 'entityName' is set
      if (entityName === undefined || entityName === null) {
        throw new Error("Missing the required parameter 'entityName' when calling deleteContentSitemapNode");
      }
      // verify the required parameter 'entityId' is set
      if (entityId === undefined || entityId === null) {
        throw new Error("Missing the required parameter 'entityId' when calling deleteContentSitemapNode");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling deleteContentSitemapNode");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteContentSitemapNode");
      }

      let pathParams = {
        'entity_name': entityName,
        'entity_id': entityId,
        'sitemap_name': sitemapName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/{entity_name}/{entity_id}/sitemaps/{sitemap_name}/nodes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteSitemap operation.
     * @callback module:api/SitemapApi~deleteSitemapCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Sitemap resource.
     * @param {String} id 
     * @param {module:api/SitemapApi~deleteSitemapCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteSitemap(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteSitemap");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/sitemaps/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteSitemapNode operation.
     * @callback module:api/SitemapApi~deleteSitemapNodeCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the SitemapNode resource.
     * @param {String} sitemapName 
     * @param {String} id 
     * @param {module:api/SitemapApi~deleteSitemapNodeCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteSitemapNode(sitemapName, id, callback) {
      let postBody = null;
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling deleteSitemapNode");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteSitemapNode");
      }

      let pathParams = {
        'sitemap_name': sitemapName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getContentSitemapNode operation.
     * @callback module:api/SitemapApi~getContentSitemapNodeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContentSitemapNodeRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ContentSitemapNode resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} entityName 
     * @param {String} entityId 
     * @param {String} sitemapName 
     * @param {String} id 
     * @param {module:api/SitemapApi~getContentSitemapNodeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContentSitemapNodeRead}
     */
    getContentSitemapNode(acceptLanguage, entityName, entityId, sitemapName, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getContentSitemapNode");
      }
      // verify the required parameter 'entityName' is set
      if (entityName === undefined || entityName === null) {
        throw new Error("Missing the required parameter 'entityName' when calling getContentSitemapNode");
      }
      // verify the required parameter 'entityId' is set
      if (entityId === undefined || entityId === null) {
        throw new Error("Missing the required parameter 'entityId' when calling getContentSitemapNode");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling getContentSitemapNode");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getContentSitemapNode");
      }

      let pathParams = {
        'entity_name': entityName,
        'entity_id': entityId,
        'sitemap_name': sitemapName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ContentSitemapNodeRead;
      return this.apiClient.callApi(
        '/{entity_name}/{entity_id}/sitemaps/{sitemap_name}/nodes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getContentSitemapNodeList operation.
     * @callback module:api/SitemapApi~getContentSitemapNodeListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ContentSitemapNodeList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of ContentSitemapNode resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} entityName 
     * @param {String} entityId 
     * @param {String} sitemapName 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/SitemapApi~getContentSitemapNodeListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ContentSitemapNodeList>}
     */
    getContentSitemapNodeList(acceptLanguage, entityName, entityId, sitemapName, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getContentSitemapNodeList");
      }
      // verify the required parameter 'entityName' is set
      if (entityName === undefined || entityName === null) {
        throw new Error("Missing the required parameter 'entityName' when calling getContentSitemapNodeList");
      }
      // verify the required parameter 'entityId' is set
      if (entityId === undefined || entityId === null) {
        throw new Error("Missing the required parameter 'entityId' when calling getContentSitemapNodeList");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling getContentSitemapNodeList");
      }

      let pathParams = {
        'entity_name': entityName,
        'entity_id': entityId,
        'sitemap_name': sitemapName
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [ContentSitemapNodeList];
      return this.apiClient.callApi(
        '/{entity_name}/{entity_id}/sitemaps/{sitemap_name}/nodes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getSitemap operation.
     * @callback module:api/SitemapApi~getSitemapCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a Sitemap resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/SitemapApi~getSitemapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapRead}
     */
    getSitemap(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getSitemap");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSitemap");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapRead;
      return this.apiClient.callApi(
        '/sitemaps/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getSitemapList operation.
     * @callback module:api/SitemapApi~getSitemapListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/SitemapList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Sitemap resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {Object} opts Optional parameters
     * @param {String} opts.search The `search` property concatenates all supported search and order-by fields, to filter results and sort them in the specified order. It must be a valid StringQuery value. For in-depth documentation on how to construct it and which operators are supported, see the [RollerworksSearch documentation](https://rollerworkssearch.readthedocs.io/en/latest/reference/input/string_query.html).  Supported search fields are:  * **id** (text) * **client** (text) * **created_at** (datetime) * **name** (text) * **nestable** (text) * **sortable** (text) * **scope** (text)  Supported order-by fields are:  * created_at * updated_at  ### Examples ---  Text field containing the search term, and a date greater than or equal to the specified value: ``` name:something;created_at:>=2000-01-01T00:00:00Z ```  Search where date between two values, order by name (ascending): ``` created_at:2020-01-01T00:00:00Z~2021-12-31T00:00:00Z;@name:ASC ``` 
     * @param {Number} opts.page The list page number
     * @param {module:api/SitemapApi~getSitemapListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/SitemapList>}
     */
    getSitemapList(acceptLanguage, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getSitemapList");
      }

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [SitemapList];
      return this.apiClient.callApi(
        '/sitemaps', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getSitemapNode operation.
     * @callback module:api/SitemapApi~getSitemapNodeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapNodeRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a SitemapNode resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} sitemapName 
     * @param {String} id 
     * @param {module:api/SitemapApi~getSitemapNodeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapNodeRead}
     */
    getSitemapNode(acceptLanguage, sitemapName, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getSitemapNode");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling getSitemapNode");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSitemapNode");
      }

      let pathParams = {
        'sitemap_name': sitemapName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapNodeRead;
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getSitemapNodeList operation.
     * @callback module:api/SitemapApi~getSitemapNodeListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/SitemapNodeList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of SitemapNode resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} sitemapName 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search The `search` property concatenates all supported search and order-by fields, to filter results and sort them in the specified order. It must be a valid StringQuery value. For in-depth documentation on how to construct it and which operators are supported, see the [RollerworksSearch documentation](https://rollerworkssearch.readthedocs.io/en/latest/reference/input/string_query.html).  Supported search fields are:  * **id** (text) * **client** (text) * **owned_by** (text) * **owned_by_display_name** (text) * **created_at** (datetime) * **title** (text) * **slug** (text) * **slug__keyword** (text, exact match) * **description** (text) * **parent** (text) * **origin** (text) * **depth** (integer) * **state** (text) * **published_at** (datetime) * **root** (text)  Supported order-by fields are:  * position * created_at * updated_at * title * slug * published_at  ### Examples ---  Text field containing the search term, and a date greater than or equal to the specified value: ``` title:something;created_at:>=2000-01-01T00:00:00Z ```  Search by origin identifier: ``` origin:SN-0123 ```  Search where date between two values, order by title (ascending): ``` created_at:2020-01-01T00:00:00Z~2021-12-31T00:00:00Z;@title:ASC ```  Search by numeric extended attribute (always prefixed with *attr_*), having a value greater than: ``` attr_number_of_likes:>10 ``` 
     * @param {Number} opts.page The list page number
     * @param {module:api/SitemapApi~getSitemapNodeListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/SitemapNodeList>}
     */
    getSitemapNodeList(acceptLanguage, sitemapName, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getSitemapNodeList");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling getSitemapNodeList");
      }

      let pathParams = {
        'sitemap_name': sitemapName
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [SitemapNodeList];
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getSitemapNodeVersion operation.
     * @callback module:api/SitemapApi~getSitemapNodeVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapNodeVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the SitemapNode resource version.
     * @param {String} sitemapName 
     * @param {String} sitemapNodeId 
     * @param {String} id 
     * @param {module:api/SitemapApi~getSitemapNodeVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapNodeVersionRead}
     */
    getSitemapNodeVersion(sitemapName, sitemapNodeId, id, callback) {
      let postBody = null;
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling getSitemapNodeVersion");
      }
      // verify the required parameter 'sitemapNodeId' is set
      if (sitemapNodeId === undefined || sitemapNodeId === null) {
        throw new Error("Missing the required parameter 'sitemapNodeId' when calling getSitemapNodeVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSitemapNodeVersion");
      }

      let pathParams = {
        'sitemap_name': sitemapName,
        'sitemap_node_id': sitemapNodeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapNodeVersionRead;
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes/{sitemap_node_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getSitemapNodeVersionList operation.
     * @callback module:api/SitemapApi~getSitemapNodeVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/SitemapNodeVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of SitemapNode versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} sitemapName 
     * @param {String} sitemapNodeId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/SitemapApi~getSitemapNodeVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/SitemapNodeVersionList>}
     */
    getSitemapNodeVersionList(acceptLanguage, sitemapName, sitemapNodeId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getSitemapNodeVersionList");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling getSitemapNodeVersionList");
      }
      // verify the required parameter 'sitemapNodeId' is set
      if (sitemapNodeId === undefined || sitemapNodeId === null) {
        throw new Error("Missing the required parameter 'sitemapNodeId' when calling getSitemapNodeVersionList");
      }

      let pathParams = {
        'sitemap_name': sitemapName,
        'sitemap_node_id': sitemapNodeId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [SitemapNodeVersionList];
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes/{sitemap_node_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateSitemap operation.
     * @callback module:api/SitemapApi~updateSitemapCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Sitemap resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/SitemapUpdate} sitemap Required properties are: * name 
     * @param {module:api/SitemapApi~updateSitemapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapRead}
     */
    updateSitemap(acceptLanguage, id, sitemap, callback) {
      let postBody = sitemap;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateSitemap");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateSitemap");
      }
      // verify the required parameter 'sitemap' is set
      if (sitemap === undefined || sitemap === null) {
        throw new Error("Missing the required parameter 'sitemap' when calling updateSitemap");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapRead;
      return this.apiClient.callApi(
        '/sitemaps/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateSitemapNode operation.
     * @callback module:api/SitemapApi~updateSitemapNodeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapNodeRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the SitemapNode resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} sitemapName 
     * @param {String} id 
     * @param {module:model/SitemapNodeUpdate} sitemapNode Required properties are: * title   For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/SitemapApi~updateSitemapNodeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapNodeRead}
     */
    updateSitemapNode(acceptLanguage, sitemapName, id, sitemapNode, callback) {
      let postBody = sitemapNode;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateSitemapNode");
      }
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling updateSitemapNode");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateSitemapNode");
      }
      // verify the required parameter 'sitemapNode' is set
      if (sitemapNode === undefined || sitemapNode === null) {
        throw new Error("Missing the required parameter 'sitemapNode' when calling updateSitemapNode");
      }

      let pathParams = {
        'sitemap_name': sitemapName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapNodeRead;
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateSitemapNodeVersion operation.
     * @callback module:api/SitemapApi~updateSitemapNodeVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapNodeVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the SitemapNode resource version.
     * @param {String} sitemapName 
     * @param {String} sitemapNodeId 
     * @param {String} id 
     * @param {module:model/SitemapNodeVersionWrite} sitemapNode Required properties are: * title   For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/SitemapApi~updateSitemapNodeVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapNodeVersionRead}
     */
    updateSitemapNodeVersion(sitemapName, sitemapNodeId, id, sitemapNode, callback) {
      let postBody = sitemapNode;
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling updateSitemapNodeVersion");
      }
      // verify the required parameter 'sitemapNodeId' is set
      if (sitemapNodeId === undefined || sitemapNodeId === null) {
        throw new Error("Missing the required parameter 'sitemapNodeId' when calling updateSitemapNodeVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateSitemapNodeVersion");
      }
      // verify the required parameter 'sitemapNode' is set
      if (sitemapNode === undefined || sitemapNode === null) {
        throw new Error("Missing the required parameter 'sitemapNode' when calling updateSitemapNodeVersion");
      }

      let pathParams = {
        'sitemap_name': sitemapName,
        'sitemap_node_id': sitemapNodeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapNodeVersionRead;
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes/{sitemap_node_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateSitemapNodeVersionOptions operation.
     * @callback module:api/SitemapApi~updateSitemapNodeVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SitemapNodeVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the SitemapNode resource version options.
     * @param {String} sitemapName 
     * @param {String} sitemapNodeId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject19} opts.sitemapNode 
     * @param {module:api/SitemapApi~updateSitemapNodeVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SitemapNodeVersionRead}
     */
    updateSitemapNodeVersionOptions(sitemapName, sitemapNodeId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['sitemapNode'];
      // verify the required parameter 'sitemapName' is set
      if (sitemapName === undefined || sitemapName === null) {
        throw new Error("Missing the required parameter 'sitemapName' when calling updateSitemapNodeVersionOptions");
      }
      // verify the required parameter 'sitemapNodeId' is set
      if (sitemapNodeId === undefined || sitemapNodeId === null) {
        throw new Error("Missing the required parameter 'sitemapNodeId' when calling updateSitemapNodeVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateSitemapNodeVersionOptions");
      }

      let pathParams = {
        'sitemap_name': sitemapName,
        'sitemap_node_id': sitemapNodeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = SitemapNodeVersionRead;
      return this.apiClient.callApi(
        '/sitemaps/{sitemap_name}/nodes/{sitemap_node_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
